import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {AvtaledetaljerModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {GruppeKortKomponent} from "../../../gruppe/komponenter/gruppe-kort/gruppe-kort";
import {KortSamlingKomponent} from "web-ng2/delt/komponenter/kort/kort-samling/kort-samling";

const debug = initDebugger('AvtaleGrupperVisKomponent');

/**
 * Lister grupper tilknyttet avtalen
 */
@Component({
    selector: 'avtale-grupper-vis',
    templateUrl: 'avtale-grupper-vis.html',
    styleUrl: 'avtale-grupper-vis.scss',
    imports: [
        GruppeKortKomponent,
        KortSamlingKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvtaleGrupperVisKomponent {
    static ajsSelector = 'avtaleGrupperVis';

    @Input({required:true}) avtale!:AvtaledetaljerModell;

    constructor() {
    }
}

